import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-flexbox-grid';
import { Loop as LoopIcon } from '@material-ui/icons';
import SelectorCantidad from '../Common/selectorCantidad/selectorCantidad';
import ArticuloAlternativa from '../MostrarArticulos/articuloAlternativa/articuloAlternativa';
import './styles.css';

class ItemResumenPedido extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cantidadPedido: this.props.pedidoDetalle.cantidad ? this.props.pedidoDetalle.cantidad : 0,
      showArticuloAlternativa: false,
      imageError: false,
      isEditing: false
    }
    this.timeoutId = null;
  }

  componentDidUpdate(prevProps) {
    // Sync with global state only when not editing
    if (!this.state.isEditing &&
      prevProps.pedidoDetalle.cantidad !== this.props.pedidoDetalle.cantidad) {
      this.setState({
        cantidadPedido: this.props.pedidoDetalle.cantidad || 0
      });
    }
  }

  componentWillUnmount() {
    // Cleanup timeout
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
  
  agregarQuitarUnidad = (cantidad, alternativa) => {
    // Aqui se evita llamar mas de unas vez a la API dentro de los 300ms
    this.setState({ cantidadPedido: cantidad, showArticuloAlternativa: false }, () => {
      setTimeout(() => {
        if (this.state.cantidadPedido === cantidad) {
          let articulo = {
            idArticulo: this.props.pedidoDetalle.idArticulo,
            nombre: this.props.pedidoDetalle.descripcion,
            idCatalogoEntrada: this.props.pedidoDetalle.idCatalogoEntrada,
          }

          this.props.handleAgregarQuitarUnidad(cantidad, articulo, alternativa);
        }
      }, 1500);
    });
  }

  onChangeCantidad = (cantidad) => {
    // Clear any existing timeout
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.setState({
      cantidadPedido: cantidad,
      showArticuloAlternativa: false,
      isEditing: true
    }, () => {
      this.timeoutId = setTimeout(() => {
        if (this.state.cantidadPedido === cantidad) {
          let articulo = {
            idArticulo: this.props.pedidoDetalle.idArticulo,
            nombre: this.props.pedidoDetalle.descripcion,
            idCatalogoEntrada: this.props.pedidoDetalle.idCatalogoEntrada,
          }

          this.props.handleAgregarQuitarUnidad(cantidad, articulo);
          this.setState({ isEditing: false });
        }
      }, 300);
    });
  }

  handleImageError = () => {
    this.setState({ imageError: true });
  };


  render() {
    const { pedidoDetalle, logoCard } = this.props;
    const { imageError } = this.state;

    const hasCatalogDiscount = pedidoDetalle.catalogoDiscount > 0;
    const getApplicablePromo = () => {
      const promos = pedidoDetalle.promoPorCantidad || [];
      if (!Array.isArray(promos) || promos.length === 0) return null;
      const cantidad = pedidoDetalle.cantidad || 0;
      const applicable = promos
        .filter((p) => p && p.cantidad <= cantidad)
        .sort((a, b) => b.cantidad - a.cantidad)[0];
      return applicable || null;
    };
    const applicablePromo = getApplicablePromo();
    const hasDisccountMajor = !!applicablePromo;
    const imageAvailable = pedidoDetalle.imagenArticulo && !imageError;

    const calcularPrecioUnitario = () => {
      if (applicablePromo) return (applicablePromo.precioUnitarioConDescuento).toFixed(2);
      if (hasCatalogDiscount) return (pedidoDetalle.precioUnitario * (1 - pedidoDetalle.catalogoDiscount / 100)).toFixed(2);
      return (pedidoDetalle.precioUnitario).toFixed(2);
    }

    const calcularSubtotal = () => {
      const cantidad = pedidoDetalle.cantidad || 0;
      let precio = pedidoDetalle.precioUnitario;
      if (applicablePromo) precio = applicablePromo.precioUnitarioConDescuento;
      else if (hasCatalogDiscount) precio = pedidoDetalle.precioUnitario * (1 - pedidoDetalle.catalogoDiscount / 100);

      return (precio * cantidad).toFixed(2);
    }
    
    return (
      <div className="itemResumenPedido">
        <div className="imageContainer">
            <div className={imageAvailable ? 'imgPedidoDetalle' : 'imageDefault'}>
              <img
                alt=""
                src={imageAvailable ? pedidoDetalle.imagenArticulo : logoCard}
                onError={this.handleImageError}
              />
              {!imageAvailable && (<div>Producto sin foto</div>)}
            </div>
        </div>

        <div className='containerInfoPd'>
          <div className="headerProducto">
            <div className='nombreArticuloPedido'>
              {pedidoDetalle.codigoBarra 
                ? `${pedidoDetalle.codigoBarra + " - " + pedidoDetalle.descripcion}`
                : pedidoDetalle.descripcion}
            </div>
          </div>

          {this.props.pedidoDetalle.alternativa && (
            <>
              <div className="containerAlternativa" onClick={() => this.setState({ showArticuloAlternativa: true })}>
                <div className="textoAlternativa">{this.props.pedidoDetalle.alternativa}</div>
                <div className="iconContainer"><LoopIcon /></div>
              </div>

              {this.state.showArticuloAlternativa && (
                <ArticuloAlternativa
                  open={this.state.showArticuloAlternativa}
                  itemId={this.props.pedidoDetalle.idArticulo}
                  initialValue={this.state.cantidadPedido}
                  alternativaSeleccionada={this.props.pedidoDetalle.alternativa}
                  onClose={() => this.setState({ showArticuloAlternativa: false })}
                  onConfirm={this.agregarQuitarUnidad}
                />
              )}
            </>
          )}
          <Row className='unidadesPrecio'>
          <div className='unidades'>{this.props.pedidoDetalle.productoPesable ? 'Kg' : 'Unidad' }</div>
          <div className='precioxMayor'>
            <div className="precioListaTachado">$ {pedidoDetalle.precioUnitario.toFixed(2)}</div>
            <div className="precioPromocional">{hasCatalogDiscount || hasDisccountMajor ? "$ " + calcularPrecioUnitario() : null}</div>
          </div>
          </Row>
          <div className='containerDetalle'>
            <div className='subtotalBox'>
              <div className='subtotalLabel'>Subtotal</div>
              <div className='precio'> ${calcularSubtotal()}</div>
            </div>
            <div xs={6} className="selectorCantidadContainer">
              <SelectorCantidad {...this.props.pedidoDetalle} value={this.state.cantidadPedido} onChange={this.onChangeCantidad} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ItemResumenPedido.defaultProps = {
  open: true
}

ItemResumenPedido.propTypes = {
  pedidoDetalle: PropTypes.object.isRequired,
  handleOnClose: PropTypes.func,
  handleAgregarQuitarUnidad: PropTypes.func.isRequired,
};

export default (ItemResumenPedido);
